var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "38px",
    viewBox: "0 0 44 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "caution") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caution",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#F64C66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9858989,1.14795239 L43.5565364,33.4868738 C44.2370887,34.611623 43.8789659,36.077133 42.7546269,36.7598462 C42.3834166,36.9850343 41.9562867,37.1041815 41.5208284,37.1041815 L2.37955347,37.1041815 C1.06603995,37.1041815 6.4659389e-13,36.036623 6.4659389e-13,34.7212383 C6.4659389e-13,34.2851597 0.118977673,33.8586129 0.345035253,33.4868738 L19.9156727,1.14795239 C20.596225,0.0232032266 22.0596504,-0.336621188 23.1839894,0.344900551 C23.5123678,0.543876303 23.7872062,0.820297708 23.9858989,1.14795239 Z M20.1300012,30.6666321 C20.503519,31.0437072 20.9754557,31.2346163 21.5458115,31.2346163 C22.101938,31.2346163 22.562017,31.0437072 22.9284202,30.6666321 C23.2948233,30.2871854 23.4786178,29.8199918 23.4786178,29.2650511 C23.4786178,28.7101103 23.2948233,28.2476597 22.9284202,27.8765135 C22.562017,27.506553 22.101938,27.3215728 21.5458115,27.3215728 C20.9754557,27.3215728 20.503519,27.506553 20.1300012,27.8765135 C19.7552976,28.2476597 19.5655743,28.7101103 19.5655743,29.2650511 C19.5655743,29.8199918 19.7552976,30.2871854 20.1300012,30.6666321 Z M21.5225797,11.6693989 C20.4027401,11.6693989 19.5111142,12.6539666 19.5681676,13.8284326 L20.0604194,23.9172284 C20.1002242,24.7288316 20.7384266,25.3650511 21.5119651,25.3650511 C22.2841768,25.3650511 22.9210525,24.7312507 22.962184,23.920857 L23.475665,13.8332708 C23.5366989,12.6563857 22.6437462,11.6693989 21.5225797,11.6693989 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.c022921c1d98e2a76652650547f736d9.svg";
export { ForwardRef as ReactComponent };